import React, { Component } from 'react';
import classnames from 'classnames';
import axios from 'axios';

import Dropdown from './components/Dropdown';
import NewContract from './components/NewContract';
import VisualizeMain from './components/VisualizeMain';
import VisualizeEvents from './components/VisualizeEvents';
import VisualizeFilter from './components/VisualizeFilter';
import Menu from './components/Menu';
import Notification from './components/Notification';

import * as Constants from './constants/app';
import defaultContracts from './constants/contracts';

class App extends Component {

  constructor(props) {
    super(props);
    let savedContracts = window.localStorage ? window.localStorage.getItem('contracts') : false;
    savedContracts = savedContracts ? JSON.parse(savedContracts) : defaultContracts;

    this.state = {
      contract: savedContracts[0],
      modalAddContract: false,
      page: 'Functions',
      loading: false,
      contractData: null,
      savedContracts
    }
  }

  componentDidMount() {
    this.loadCurrentContract();
  }

  loadCurrentContract = () => {
    const { contract } = this.state;

    this.setLoading();
    axios.post(`${Constants.API_ADDRESS}/query`, contract)
      .then((response) => {
        this.setState({
          contractData: response.data
        })
        this.setLoading(false);
      }).catch(err => {
        this.setLoading(false);
      });
  }

  showAddContract = (value = true) => () => {
    this.setState({ modalAddContract: !!value });
  }

  setLoading = (value = true) => {
    this.setState({ loading: !!value });
  }

  setPage = (value = 'Functions') => {
    this.setState({ page: value });
  }

  changeContract = (evt) => {
    const name = evt.target.value;
    const { savedContracts } = this.state;

    if (name === Constants.ADD_NEW_CONTRACT) {
      this.showAddContract(true)();
    } else {

      const contract = savedContracts.find(i => i.name === name);
      this.setState({
        contract
      }, this.loadCurrentContract);
    }
  }

  saveContract(contract) {
    const { savedContracts } = this.state;
    const newSavedContracts = [...savedContracts, contract];

    this.setState({
      savedContracts: newSavedContracts,
      modalAddContract: false
    });

    if (window.localStorage) {
      window.localStorage.setItem('contracts', JSON.stringify(newSavedContracts));
    }
  }

  renderMain() {
    const {
      page,
      contract,
      contractData
    } = this.state;

    let markup = (
      <VisualizeMain
        contract={contract}
        contractData={contractData}
      />
    );

    if (page === 'Events') {
      markup = (
        <VisualizeEvents
          contract={contract}
          contractData={contractData}
        />
      );
    }

    if (page === 'Funnels') {
      markup = (
        <VisualizeFilter
          contract={contract}
          contractData={contractData}
        />
      );
    }

    return markup;
  }

  render() {
    const {
      modalAddContract,
      contract,
      savedContracts,
      loading,
      page
    } = this.state;

    return (
      <div className="App">
        <div className="Sidebar">
          <div>
            <h1 className="Sidebar-title">Rufflet</h1>

            <Dropdown
              title="Smart Contract"
              options={savedContracts.map(c => ({
                text: c.name, value: c.name
              })).concat([
                {text: 'Add new...', value: Constants.ADD_NEW_CONTRACT}
              ])}
              invert
              full
              onChange={this.changeContract}
              value={contract ? contract.name : ''}
            />

            {
              modalAddContract ? (
                <NewContract
                  onDismiss={this.showAddContract(false)}
                  onSave={contract => this.saveContract(contract)}
                />
              ) : null
            }

            <Menu
              selected={page}
              options={["Functions", "Events", "Funnels"]}
              onClick={this.setPage}
            />
          </div>

          <Notification />

        </div>
        <div
          className={classnames('App-main', {
            'App-main--loading': loading
          })}
        >
          { this.renderMain() }
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js